import { css } from "lit";

export default css`
  :host {
    --mh-red: #E21A23;
    --mh-light-red: #F16659;
    --mh-yellow: #F7D117;
    --mh-orange: #F47921;
    --mh-dark-plum: #452445;
    --mh-teal: #7AC1AC;
    --mh-dark-teal: #01708c;
    --mh-blue: #39858E;
    --mh-dark-blue: #32484C;
    --mh-amex-blue: #26A6D1;
    --mh-light-blue: #47B9DB;
    --mh-light-blue-1: #A3DCED;
    --mh-light-blue-2: #F4FBFD;
    --mh-dark-green: #1D6D4D;
    --mh-gray: #767676;
    --mh-gray-2: #707070;
    --mh-dark-gray: #363636;
    --mh-light-gray: #c1c5c8;
    --mh-light-gray-2: #D8D8D8;
    --mh-border-product-gray: #cbcbcb;
    --mh-lightest-gray: #eff3f4;
    --mh-black: #000000;
    --mh-white: #FFFFFF;

    --mh-font-color: var(--mh-black);

    --mh-font-size-x2: 26px;
    --mh-font-size-extra-large: 22px;
    --mh-font-size-large: 18px;
    --mh-font-size-medium: 16px;
    --mh-font-size-small: 14px;
    --mh-font-size-extra-small: 12px;

    --mh-spacing-extra-large: 32px;
    --mh-spacing-large: 24px;
    --mh-spacing-medium: 16px;
    --mh-spacing-small: 12px;
    --mh-spacing-extra-small: 8px;

    --mh-animation-speed: 250ms;

    --mh-outline: var(--mh-red) solid 2px;
    --mh-outline-offset: 3px;
    --mh-border: 2px solid var(--mh-red);
  }
`;